"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _TabContext = require("../../contexts/TabContext");
var _AuthContext = require("../../contexts/AuthContext");
var _appcenterApi = _interopRequireWildcard(require("../../../../@apis/appcenterApi"));
var _AccountType = _interopRequireDefault(require("./AccountType"));
var _ConfirmCompany = _interopRequireDefault(require("./ConfirmCompany"));
var _AdminAccount = _interopRequireDefault(require("./AdminAccount"));
var _ConfirmAddress = _interopRequireDefault(require("./ConfirmAddress"));
var _InboxRequest = _interopRequireDefault(require("../../../../@custom/InboxRequest"));
var _constants = require("../../../../@constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * @typedef CNPJData
 * @type {import("../../../../@apis/receitaApi.js").CNPJData}
 */

/**
 * @typedef CEPData
 * @type {import("../../../../@apis/cepApi.js").CEPData}
 */

/**
 * @typedef UserType
 * @type {import("../../../../@apis/appcenterApi.js").CustomerType}
 */

/**
 * @typedef User
 * @type {import("../../../../@apis/appcenterApi.js").Customer}
 */

/**
 * @typedef StepProps
 * @type {{
 *     user: User;
 *     updateUser: (updates: Partial<User>) => void;
 *     goNext: (user: User) => void;
 *     goBack?: () => void;
 * }}
 */
function Register() {
  var _useContext = (0, _react.useContext)(_TabContext.TabContext),
    setTab = _useContext.setTab;
  var _useAuth = (0, _AuthContext.useAuth)(),
    app = _useAuth.app,
    showSpinner = _useAuth.showSpinner,
    hideSpinner = _useAuth.hideSpinner,
    showMessage = _useAuth.showMessage;
  var _useState = (0, _react.useState)(STEPS.ACCOUNT_TYPE),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1];
  var _useState3 = (0, _react.useState)(_appcenterApi.defaultCustomer),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    user = _useState4[0],
    setUser = _useState4[1];
  var registerTitle = _constants.registerPageConstants[app].title;
  var registerSubtitle = _constants.registerPageConstants[app].subtitle;

  /** @param {Partial<User>} updates */
  var handleUserUpdate = function handleUserUpdate(updates) {
    setUser(function (prev) {
      return _objectSpread(_objectSpread({}, prev), updates);
    });
  };

  /** @param {User} user */
  var createAccount = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(user) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log('user', user);
            showSpinner();
            _context.prev = 2;
            _context.next = 5;
            return _appcenterApi["default"].customer.create(user);
          case 5:
            setTab('login');
            return _context.abrupt("return", true);
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);
            showMessage('Erro ao cadastrar usuário', /*#__PURE__*/_react["default"].createElement(_InboxRequest["default"], {
              error: _context.t0,
              additionalInfo: {
                user: user
              }
            }));
            return _context.abrupt("return", false);
          case 13:
            _context.prev = 13;
            hideSpinner();
            return _context.finish(13);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 9, 13, 16]]);
    }));
    return function createAccount(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  /**
   * @param {number} currentStep
   * @returns {(newUser: User) => Promise<void>}
   **/
  var handleGoNextStep = function handleGoNextStep(currentStep) {
    return /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(newUser) {
        var success, _success;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              setUser(newUser);
              console.log('currentStep', currentStep);
              _context2.t0 = currentStep;
              _context2.next = _context2.t0 === STEPS.ACCOUNT_TYPE ? 5 : _context2.t0 === STEPS.CONFIRM_COMPANY ? 7 : _context2.t0 === STEPS.ADMIN_ACCOUNT ? 9 : _context2.t0 === STEPS.CONFIRM_ADDRESS ? 18 : 24;
              break;
            case 5:
              if (newUser.type === 'company') {
                setStep(STEPS.CONFIRM_COMPANY);
              } else {
                setStep(STEPS.ADMIN_ACCOUNT);
              }
              return _context2.abrupt("break", 25);
            case 7:
              setStep(STEPS.ADMIN_ACCOUNT);
              return _context2.abrupt("break", 25);
            case 9:
              if (!(newUser.type === 'company')) {
                _context2.next = 16;
                break;
              }
              _context2.next = 12;
              return createAccount(newUser);
            case 12:
              success = _context2.sent;
              if (success) setStep(STEPS.ACCOUNT_CREATED);
              _context2.next = 17;
              break;
            case 16:
              setStep(STEPS.CONFIRM_ADDRESS);
            case 17:
              return _context2.abrupt("break", 25);
            case 18:
              console.log('creating');
              _context2.next = 21;
              return createAccount(newUser);
            case 21:
              _success = _context2.sent;
              if (_success) setStep(STEPS.ACCOUNT_CREATED);
              return _context2.abrupt("break", 25);
            case 24:
              return _context2.abrupt("break", 25);
            case 25:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
  };

  /**
   * @param {number} currentStep
   * @returns {() => void}
   **/
  var handleGoPrevStep = function handleGoPrevStep(currentStep) {
    return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.t0 = currentStep;
            _context3.next = _context3.t0 === STEPS.CONFIRM_COMPANY ? 3 : _context3.t0 === STEPS.ADMIN_ACCOUNT ? 5 : _context3.t0 === STEPS.CONFIRM_ADDRESS ? 7 : 9;
            break;
          case 3:
            setStep(STEPS.ACCOUNT_TYPE);
            return _context3.abrupt("break", 10);
          case 5:
            if (user.type === 'company') {
              setStep(STEPS.CONFIRM_COMPANY);
            } else {
              setStep(STEPS.ACCOUNT_TYPE);
            }
            return _context3.abrupt("break", 10);
          case 7:
            setStep(STEPS.ACCOUNT_TYPE);
            return _context3.abrupt("break", 10);
          case 9:
            return _context3.abrupt("break", 10);
          case 10:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
  };
  (0, _react.useEffect)(function () {
    localStorage.setItem('user', JSON.stringify(user));
  }, [JSON.stringify(user)]);
  var stepProps = {
    user: user,
    updateUser: handleUserUpdate
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Auth-right-form"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "Auth-right-form-textBox"
  }, /*#__PURE__*/_react["default"].createElement("h1", null, registerTitle), /*#__PURE__*/_react["default"].createElement("p", null, registerSubtitle)), step === STEPS.ACCOUNT_TYPE && /*#__PURE__*/_react["default"].createElement(_AccountType["default"], (0, _extends2["default"])({}, stepProps, {
    goNext: handleGoNextStep(STEPS.ACCOUNT_TYPE)
  })), step === STEPS.CONFIRM_COMPANY && /*#__PURE__*/_react["default"].createElement(_ConfirmCompany["default"], (0, _extends2["default"])({}, stepProps, {
    goNext: handleGoNextStep(STEPS.CONFIRM_COMPANY),
    goBack: handleGoPrevStep(STEPS.CONFIRM_COMPANY)
  })), step === STEPS.ADMIN_ACCOUNT && /*#__PURE__*/_react["default"].createElement(_AdminAccount["default"], (0, _extends2["default"])({}, stepProps, {
    goNext: handleGoNextStep(STEPS.ADMIN_ACCOUNT),
    goBack: handleGoPrevStep(STEPS.ADMIN_ACCOUNT)
  })), step === STEPS.CONFIRM_ADDRESS && /*#__PURE__*/_react["default"].createElement(_ConfirmAddress["default"], (0, _extends2["default"])({}, stepProps, {
    goNext: handleGoNextStep(STEPS.CONFIRM_ADDRESS),
    goBack: handleGoPrevStep(STEPS.CONFIRM_ADDRESS)
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: "Auth-right-form-centeredText"
  }, "J\xE1 tem conta?", ' ', /*#__PURE__*/_react["default"].createElement("span", {
    className: "Auth-right-form-link",
    onClick: function onClick() {
      return setTab('login');
    }
  }, "Clique aqui")));
}
var _default = Register;
exports["default"] = _default;
var STEPS = {
  ACCOUNT_TYPE: 0,
  CONFIRM_COMPANY: 1,
  ADMIN_ACCOUNT: 2,
  CONFIRM_ADDRESS: 3,
  ACCOUNT_CREATED: 4
};